import React, { useEffect, useState } from 'react';
import jsPDF from 'jspdf';
import Service from '../../../services';
import { io } from "socket.io-client";

function PdfHighlighter() {
  const [highlightedHtml, setHighlightedHtml] = useState<string>('');

  const convertPdfToHtml = (file: File) => {
    const formData = new FormData();
    formData.append('file', file);
    fetch('https://api.example.com/convert/pdf-to-html', {
      method: 'POST',
      body: formData
    })
    .then(response => response.text())
    .then(html => {
      highlightTextInHtml(html);
    })
    .catch(error => {
      console.error('Error converting PDF to HTML:', error);
    });
  };

  const highlightTextInHtml = (html: string) => {
    // Add highlighting logic here
    // Modify the HTML to add styles or markup to highlight text
    // For demonstration, let's just set the highlighted HTML directly
    setHighlightedHtml(html);
  };

  const convertHtmlToPdf = () => {
    // Convert highlighted HTML back to PDF using jsPDF
    const doc = new jsPDF();
    doc.html(highlightedHtml, {
      callback: (pdf) => {
        // Save or display the converted PDF
        pdf.save('highlighted.pdf');
      }
    });
  };

  // Example usage
  const handlePdfInputChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const file = event.target.files?.[0];
    if (file) {
      convertPdfToHtml(file);
    }
  };

  const URL_WEB_SOCKET = 'ws://localhost:5000/';
  const [info, setInfo] = useState<any>('')
  useEffect(() => {
    const socket = io(URL_WEB_SOCKET);

    // Event handlers
    socket.on('connect', () => {
      console.log('Connected to WebSocket server');
    });

    // words
    socket.on('numbers', (data:any) => {
      // Update the state by appending new data to the existing list
      setInfo((prevDataList:any) => [...prevDataList, data]);
      console.log('Received message from server:', data);
    });

    socket.on('disconnect', () => {
      console.log('Disconnected from WebSocket server');
    });

    return () => {
      socket.disconnect();
    };
  }, []);

  // ==========================================================
  const service = new Service();
  const askAPI = () =>{
    service.testSocketService().then((response:any)=>{
      setInfo('')
      console.log(response)
    }).catch((error:any)=>{
      console.log(error)
    })
  }

  return (
    <>
    <div>
      <input type="file" onChange={handlePdfInputChange} />
      <button onClick={convertHtmlToPdf}>Convert to PDF</button>
      <button onClick={()=>askAPI()}>SOCKET</button>
    </div>
    <div style={{display:'flex'}}>
      {/* {JSON.stringify(info)} */}
      <div style={{whiteSpace:'pre-wrap'}}>{info.length>0 ? info?.join(' ') : ''}</div>
    </div>
    </>
  );
}

export default PdfHighlighter;
